import styled, { css, keyframes } from 'styled-components';

import { colorSchemeConfig } from '@rebound/design-system/theme/colorScheme';
import { colors } from '@rebound/design-system/theme/system/colors';

const highlightedWrapper = keyframes`
  50% {
    transform: scale(1.05);
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }
  100% {
    transform: scale(1);
  }
`;

const borderAnimation = (scheme: string) => keyframes`
  0% {
    border: 2px solid ${colorSchemeConfig[scheme].v300};
  }
  80% {
    border: 2px solid ${colorSchemeConfig[scheme].v300};
  }
  100% {
    border: 1px solid ${colors.grayLight3};
  }
`;

const blurAnimation = keyframes`
  0% {
    filter: blur(3px);
  }
  100% {
    filter: none;
  }
`;

export const HighlightedWrapper = styled.div<{
  scheme: string;
  highlighted: boolean | null;
}>`
  ${(props) =>
    props.highlighted &&
    css`
      animation:
        ${highlightedWrapper} 3s forwards,
        ${borderAnimation(props.scheme)} 3s forwards;
    `};

  ${(props) =>
    props.highlighted === false &&
    css`
      animation: ${blurAnimation} 5s forwards;
    `}
`;
